import { george, pr, theme, ui } from "aaa";
import { NativePaper } from "components/common/NativePaper";
import { observer } from "mobx-react";
import { customColors, themeColors } from "muiTheme";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { isEmail } from "util/formValidations";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";

type IProps = {
    store: JuniorStore;
};

const adornmentStyle: React.CSSProperties = {
    position: "absolute",
    right: theme.MARGIN_SMALL,
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: ui.isDarkMode ? themeColors.george_text_color : "white",
    background: ui.isDarkMode ? "white" : "lightgrey",
    padding: 2,
    borderRadius: "50%",
    userSelect: "none",
};

export const JuniorActivateContact = observer(({ store }: IProps) => {

    const [email, setEmail] = React.useState("");
    const [showError, setShowError] = React.useState(false);
    const [userHasInteracted, setUserHasInteracted] = React.useState(false);

    React.useEffect(() => {
        if (!store.selectedChild) {
            pushRoute(JuniorRoutes.OVERVIEW);
            return;
        }

        store.loadContacts();
    }, [store.selectedChild, store.loadContacts]);

    React.useEffect(() => {
        if (store.mainContactEmail && !userHasInteracted) {
            setEmail(store.mainContactEmail);
        }
    }, [store.mainContactEmail, userHasInteracted]);

    const handleEmailChange = (event: any, value: string) => {
        setEmail(value);
        setUserHasInteracted(true);

        if (showError) {
            setShowError(false);
        }
    };

    const handleClearEmail = () => {
        setEmail("");
        setUserHasInteracted(true);
        setShowError(false);
    };

    const handleContinue = async () => {
        if (email.trim() === "" || !isEmail(email)) {
            setShowError(true);
            return;
        }

        setShowError(false);

        try {
            pushRoute(JuniorRoutes.ACTIVATE_DOCUMENTS);
        } catch (error) {
            console.error("Error creating junior contract:", error);
            pushRoute("/error");
        }
    };

    const getErrorMessage = () => {
        if (!showError) {
            return null;
        }

        if (email.trim() === "") {
            return ui.__("email.empty");
        }

        if (!isEmail(email)) {
            return ui.__("email.invalid");
        }

        return null;
    };

    const errorMessage = getErrorMessage();

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activate.contact.title")}
            ContinueButton={<george.ActionButton
                messageId="gJunior.activate.contact.continue"
                onClick={handleContinue}
                style={{ bottom: theme.ACTION_BUTTON_HEIGHT, marginBottom: theme.MARGIN }}
                buttonStyle={{
                    borderRadius: theme.BORDER_RADIUS_FULL,
                }}
            />}
            isLoading={store.contactsStore?.isLoading}
        >
            <pr.P_16_CONTENT style={{
                marginTop: theme.MARGIN_LARGE,
                color: ui.isDarkMode ? "white" : themeColors.george_text_color
            }}>
                {ui.__("gJunior.activate.contact.despcription")}
            </pr.P_16_CONTENT>
            <NativePaper
                elevated={false}
                style={{ display: "flex", flexDirection: "column", alignItems: "center", borderRadius: "10px", padding: "8px", marginTop: theme.MARGIN_MEDIUM }}
            >
                <george.TextField
                    onChange={handleEmailChange}
                    value={email}
                    hintText={ui.__("gJunior.activate.contact.yourEmail")}
                    aria-label={ui.__("common.email")}
                    style={{ width: "100%" }}
                    inputStyle={{ fontSize: 18, fontWeight: 600, color: ui.isDarkMode ? "white" : themeColors.george_text_color, paddingRight: theme.MARGIN_LARGE }}
                    inputFrameStyle={{
                        border: "none",
                        boxShadow: "none",
                    }}
                    adornment={
                        email.length > 0 ? (
                            <pr.IconClose
                                onClick={handleClearEmail}
                                style={adornmentStyle}
                            />
                        ) : undefined
                    }
                />
            </NativePaper>
            {errorMessage && (
                <p className="theme-validation-error" style={{ marginTop: 8 }}>
                    {errorMessage}
                </p>
            )}
            <pr.P_16_CONTENT style={{
                marginTop: 16,
                color: ui.isDarkMode ? "white" : customColors.georgeJuniorSecondary
            }}>
                {ui.__("gJunior.activate.contact.sentDocumentsInfo")}
            </pr.P_16_CONTENT>

        </ScreenWithBottomAction>
    );
});


// WEBPACK FOOTER //
// ./src/components/gJunior/activateStep/JuniorActivateContact.tsx